import api from "./core";

const basePath = "api/kiosk/Forms";

export default {
  async get(id) {
    return api.get(`${basePath}/${id}`);
  },
  async getVersions(id) {
    return api.get(`${basePath}/${id}/Versions`);
  }
};
